{
  "it": {
    "milestone": {
      "actions": {
        "activate": "Attiva",
        "activate_phase": "Attiva questa fase",
        "complete_phase": "Completa questa fase",
        "create": "Crea fase",
        "delete": "Elimina",
        "delete_milestones": "Elimina fase | Elimina {count} fasi",
        "move_down": "Sposta la fase in basso",
        "move_unit_back": "Riporta l'unità qui",
        "move_up": "Sposta la fase in alto",
        "new": "Fase",
        "reactivate_phase": "Riattiva questa fase"
      },
      "activate": {
        "body": "Tutti gli elementi di questa fase vengono pubblicati per questa unità e gli assegnatari ricevono una notifica.",
        "body_empty": "Non rende visibile nulla al cliente.",
        "body_intermediate": "Anche le fasi intermedie vengono completate e tutti gli elementi collegati vengono pubblicati.",
        "body_project": "Tutti gli elementi di questa fase vengono pubblicati per questo progetto e gli assegnatari ricevono una notifica.",
        "body_reactivate": "Questa fase torna a essere la fase corrente. Non viene ritirato nulla: tutto ciò che è già stato pubblicato o inviato resta. Le fasi successive tornano a essere pianificate.",
        "confirm": "Attiva",
        "confirm_publish": "Attiva e invia",
        "confirm_reactivate": "Riattiva",
        "past_warning": "Tornare a una fase precedente non annullerà quanto già accaduto. Ciò che è stato condiviso con i clienti non verrà revocato automaticamente.",
        "title": "Attiva fase",
        "title_activate": "Attivare “{name}”?",
        "title_reactivate": "Riattivare “{name}”?",
        "verb_default": "Avvia",
        "verb_share": "Condividi"
      },
      "assign": {
        "body": "Le unità selezionate passano a “{to}”. Gli elementi di “{to}” e di ogni fase saltata diventano visibili al cliente e gli assegnatari ricevono una notifica.",
        "body_phases_only": "Le unità selezionate passano a “{to}”. Il cliente vede la nuova fase.",
        "excluded": "Le unità già in “{to}” o oltre non possono essere selezionate."
      },
      "attach": {
        "add": "Aggiungi",
        "add_and_move": "Aggiungi e sposta",
        "assigned_tag": "Assegnato",
        "back": "Indietro",
        "counts": "{available} disponibili · {assigned} già assegnati",
        "description_decision": "Decisioni che il cliente deve prendere",
        "description_survey": "Questionari per raccogliere informazioni",
        "description_todo": "Attività che il cliente deve completare",
        "elsewhere_tag": "Ora in {name}",
        "empty": "Nessun elemento disponibile",
        "empty_state_description": "In base al Suo piano può aggiungere {kinds} a questa fase.",
        "intro": "Scelga il tipo di elemento che desidera collegare a questa fase.",
        "move_notice_body": "Ciò che è già stato inviato resta inviato. La fase precedente perde questo elemento.",
        "move_notice_item": "{element}, ora in {phase}",
        "move_notice_title": "Questo elemento viene spostato in «{name}» | Questi elementi vengono spostati in «{name}»",
        "next": "Avanti",
        "search": "Cerca",
        "select_intro": "Selezioni {kind} da aggiungere.",
        "subtitle": "Fase: {name}",
        "success": "Elementi aggiunti",
        "title": "Aggiungi elementi"
      },
      "complete_phase": {
        "body": "Questa unità completa questa fase e resta senza fase attiva. | {count} unità completano questa fase e restano senza fase attiva.",
        "body_sup": "Questo progetto completa questa fase e resta senza fase attiva.",
        "confirm": "Completa fase",
        "keep": "Mantieni la fase attiva",
        "title": "Completare “{name}”?"
      },
      "delete_phase": {
        "body": "Le unità che si trovano in questa fase restano senza fase attiva. Non passano al passaggio precedente o successivo. Gli elementi di questa fase vengono scollegati, non eliminati. Gli elementi già pubblicati per un'unità restano pubblicati: quelli li elimini sull'unità stessa.",
        "body_last": "Le unità che si trovano in questa fase restano senza fase attiva. Poiché è l'ultima fase, risultano poi completate. Gli elementi di questa fase vengono scollegati, non eliminati. Gli elementi già pubblicati per un'unità restano pubblicati: quelli li elimini sull'unità stessa.",
        "body_sup": "Questo progetto resta senza fase attiva. Non passa al passaggio precedente o successivo. Gli elementi di questa fase vengono scollegati, non eliminati. Gli elementi già pubblicati restano pubblicati: quelli li elimini sul progetto stesso.",
        "confirm": "Elimina fase",
        "keep": "Mantieni fase",
        "title": "Eliminare “{name}”?"
      },
      "detach": {
        "body": "Questo rimuove l'elemento da questa fase. L'elemento stesso continua a esistere e le unità che lo hanno già visto lo mantengono. Le nuove unità non lo ricevono più in questa fase.",
        "confirm": "Scollega",
        "keep": "Mantieni",
        "title": "Scollegare “{name}”?"
      },
      "filters": {
        "clear": "Cancella tutti i filtri",
        "done": "Fatto",
        "group_milestones": "Fasi",
        "group_status": "Stato",
        "group_title": "Contenuto della fase",
        "no_phase": "Nessuna fase",
        "no_units_here": "Nessuna unità qui",
        "nothing_assigned": "Niente assegnato",
        "phase_last": "Nell'ultima fase",
        "since_month_over": "Più di un mese",
        "since_quarter_over": "Più di 3 mesi",
        "since_two_weeks_over": "Più di 2 settimane",
        "title": "Filtri",
        "units_here": "Ha unità qui"
      },
      "labels": {
        "add_element": "Aggiungi elemento",
        "assign_units": "Assegna unità",
        "assigned_count": "0 assegnati | 1 assegnato | {count} assegnati",
        "assigned_elements": "Elementi assegnati",
        "assigned_empty_description": "Colleghi {kinds} a questa fase",
        "assigned_empty_title": "Nessun elemento ancora",
        "bulk_assign_title": "Selezioni le unità a cui desidera assegnare la fase '{milestone_name}'",
        "complete_units": "Completa {count} unità | Completa {count} unità",
        "completed_subtitle": "Queste unità hanno percorso il workflow",
        "completed_title": "Completato",
        "detach": "Scollega",
        "detach_element": "Scollega {name}",
        "drag_to_reorder": "Trascina per riordinare",
        "edit_milestone": "Modifica fase",
        "element_count": "{count} elemento | {count} elementi",
        "elements_assign_link": "Assegna elementi in Tappe",
        "elements_empty": "Nessun elemento è ancora assegnato a questa fase.",
        "elements_visible": "Visibile al cliente: {elements}",
        "empty_state_subtitle": "Le fasi rendono il processo di costruzione più trasparente per gli acquirenti",
        "empty_state_title": "Crea una nuova fase",
        "kind_decision": "Decisione | Decisioni",
        "kind_decision_count": "{count} decisione | {count} decisioni",
        "kind_survey": "Questionario | Questionari",
        "kind_survey_count": "{count} questionario | {count} questionari",
        "kind_todo": "Attività | Attività",
        "kind_todo_count": "{count} attività | {count} attività",
        "locked_not_sent": "{count} elemento è bloccato dal Suo piano e non verrà inviato. | {count} elementi sono bloccati dal Suo piano e non verranno inviati.",
        "locked_tooltip": "Non incluso nel Suo piano attuale. Non verrà inviato ai clienti.",
        "milestone": "Fase",
        "milestone_current": "Fase attuale",
        "milestone_name": "Nome fase",
        "move_units_to": "Sposta {count} unità in {name} | Sposta {count} unità in {name}",
        "new_milestone": "Nuova fase",
        "no_phase": "Nessuna fase",
        "no_results": "Nessuna fase trovata",
        "please_select": "Selezioni una nuova fase",
        "position": "Posizione",
        "progress": "Avanzamento",
        "publishes_empty": "Nulla ancora assegnato",
        "publishes_summary": "Rende {elements} visibili al cliente",
        "reorder_filtered": "Cancella la ricerca o il filtro per riordinare le fasi",
        "search_empty_state": "Nessuna fase creata. Faccia clic qui per iniziare",
        "search_phase": "Cerca fase",
        "search_unit": "Cerca unità",
        "search_units": "Cerca unità",
        "since": "Dal",
        "started_on": "Iniziata il {date}",
        "status_active": "In corso",
        "status_completed": "Completata",
        "status_planned": "Pianificata",
        "unit_active_since": "In corso dal {date}",
        "unit_completed_on": "Completata il {date}",
        "unit_timeline_empty": "Non sono ancora state create fasi per questo progetto.",
        "units": "Unità",
        "units_completed": "Nessuna unità completata | 1 unità completata | {count} unità completate",
        "units_empty": "Nessuna unità ha ancora raggiunto questa fase.",
        "units_here": "Nessuna unità qui | 1 unità qui | {count} unità qui",
        "units_no_results": "Nessuna unità trovata",
        "units_without_milestone": "1 unità senza fase | {count} unità senza fase",
        "unstarted_subtitle": "Queste unità non hanno una fase attiva",
        "unstarted_title": "Non in una fase",
        "warning_delete": "Attenzione: se elimina una fase assegnata a un'unità, il cliente perderà la visione della fase in cui si trova la propria unità. Assegni una nuova fase a queste unità."
      },
      "move": {
        "body": "Questa unità passa da “{from}” a “{to}”. Gli elementi di “{to}” diventano visibili al cliente e gli assegnatari ricevono una notifica. | Queste unità passano da “{from}” a “{to}”. Gli elementi di “{to}” diventano visibili al cliente e gli assegnatari ricevono una notifica.",
        "body_phases_only": "Questa unità passa da “{from}” a “{to}”. Il cliente vede la nuova fase. | Queste unità passano da “{from}” a “{to}”. Il cliente vede la nuova fase.",
        "confirm": "Sposta e notifica",
        "confirm_phases_only": "Sposta",
        "elements": "Rende {elements} visibile al cliente",
        "elements_empty": "Non rende visibile nulla al cliente",
        "title": "Spostare {count} unità in “{name}”? | Spostare {count} unità in “{name}”?"
      },
      "overview": {
        "no_phase": "Nessuna fase",
        "not_started": "Non iniziato",
        "since_date": "Dal {date}",
        "step_of": "Passo {step} di {total}"
      },
      "publication_failed": {
        "body": "L'invio degli elementi di questa fase non è riuscito per 1 unità. | L'invio degli elementi di questa fase non è riuscito per {count} unità.",
        "retried": "Gli elementi vengono inviati di nuovo",
        "retry": "Invia di nuovo"
      },
      "reorder": {
        "body_earlier": "Anticipare questa fase non ritira nulla di ciò che è già stato pubblicato. Le unità mantengono ciò che hanno; cambia solo l'ordine.",
        "body_earlier_sup": "Anticipare questa fase non ritira nulla di ciò che è già stato pubblicato. Il progetto mantiene ciò che ha; cambia solo l'ordine.",
        "body_later": "Posticipare questa fase non ritira nulla di ciò che è già stato pubblicato. Le unità mantengono ciò che hanno; cambia solo l'ordine.",
        "body_later_sup": "Posticipare questa fase non ritira nulla di ciò che è già stato pubblicato. Il progetto mantiene ciò che ha; cambia solo l'ordine.",
        "body_passed": "Le unità in una fase successiva superano ora questa fase. Tutto ciò che vi è collegato viene pubblicato subito per loro.",
        "body_passed_sup": "Questo progetto supera ora questa fase. Tutto ciò che vi è collegato viene pubblicato subito.",
        "body_passes": "Le unità in questa fase superano ora le fasi intermedie. Tutto ciò che è collegato a quelle fasi viene pubblicato subito per loro.",
        "body_passes_sup": "Questo progetto supera ora le fasi intermedie. Tutto ciò che è collegato a quelle fasi viene pubblicato subito.",
        "confirm": "Sposta fase",
        "count": "{count} unità supera {phases} in una volta | {count} unità superano {phases} in una volta",
        "count_sup": "Questo progetto supera {phases} in una volta",
        "crossed": "{name} ({elements})",
        "nothing": "nulla",
        "phases": "{count} fase | {count} fasi",
        "title": "Collocare “{name}” dopo “{previous}”?",
        "title_first": "Collocare “{name}” per prima?"
      },
      "toasts": {
        "bulk_assigned": "La fase è stata assegnata con successo alle unità selezionate",
        "create_success": "Fase creata con successo",
        "deleted": "Fase eliminata",
        "phase_without_units": "Non ci sono più unità in questa fase",
        "sup_assigned": "La fase è stata attivata con successo",
        "sup_completed": "Fase completata",
        "units_completed": "{count} unità completata | {count} unità completate",
        "units_moved": "{count} unità spostata | {count} unità spostate",
        "update_success": "Le fasi sono state aggiornate con successo"
      },
      "validation": {
        "needName": "Nome obbligatorio",
        "needNamePrimary": "Il nome nella lingua principale ({language}) è obbligatorio"
      }
    }
  }
}
